import React, { Component } from "react";
import "./ConferenceBtnGroup.css";

export default class AdminAddConference extends React.PureComponent{

  render() {
    const { current, handleCurrent } = this.props
    return (
      <div className="add-conference-wrapper">
        <div className="add-conference-btn">
          <button
            className={ current === 0? "conference-btn selected" : 'conference-btn' }
            onClick={ handleCurrent(0) }
          >
            การประชุม
          </button>
        </div>
        <div className="add-conference-btn">
          <button 
            className={ current === 1? "conference-btn selected" : 'conference-btn' }
            onClick={ handleCurrent(1) }  
          >
          + สร้างการประชุม
          </button>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ConferenceBtnGroup/ConferenceBtnGroup.js